import React from 'react';
import { colors } from 'crono-fe-common/theme';
import IProps from './interface';

const InsightsIcon = ({
  color = colors.black,
  className,
  onClick,
  style,
}: IProps) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
    style={style}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.09438 10.1697C2.97375 9.96645 2.97375 9.70919 3.09438 9.50592C4.364 7.35789 6.68332 5.50577 9.00263 5.50577C11.3219 5.50577 13.6406 7.35789 14.9102 9.50525C15.0308 9.70919 15.0308 9.96711 14.9102 10.1711C13.6406 12.3178 11.3219 14.1699 9.00263 14.1699C6.68332 14.1699 4.364 12.3178 3.09438 10.1697Z"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.4156 8.42427C11.1967 9.20537 11.1967 10.471 10.4156 11.2521C9.63451 12.0332 8.36888 12.0332 7.58778 11.2521C6.80668 10.471 6.80668 9.20537 7.58778 8.42427C8.36888 7.64316 9.63517 7.64316 10.4156 8.42427"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.00106 1V2.84122"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.8457 2.47296L5.083 3.94593"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.1553 2.47296L12.918 3.94593"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default InsightsIcon;
